import { Directive, effect, ElementRef, inject, input } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[focusSelectOn]',
})
export class FocusSelectOnDirective {
    // quando passa a true, fa focus+select
    readonly focusSelectOn = input(false);

    private readonly el = inject<ElementRef<HTMLInputElement | HTMLTextAreaElement>>(ElementRef);

    constructor() {
        effect(() => {
            if (!this.focusSelectOn()) return;

            // rAF è spesso più affidabile in contesti virtualizzati (AG Grid)
            requestAnimationFrame(() => {
                const native = this.el.nativeElement;
                native.focus();
                native.select?.();
            });
        });
    }
}
